<input type="checkbox" id="show-menu" role="button">
<ul id="menu">
  <li><label for="show-menu"><a routerLink="/">Home</a></label></li>
  <li><a routerLink="/menu">Menu</a></li>
  <li><a routerLink="/photogallery">Gallery</a></li>
  <!-- <li><a href="https://chezwafi-betterresto.netlify.app/" target="blank">Order Online</a></li> -->
  <li><a routerLink="/aboutUs">About Us</a></li>
  <li><a routerLink="/contactUs">Contact Us</a></li>
</ul>
